// @ts-nocheck - TODO: Fix TypeScript errors systematically

/**
 * CollapsiblePanel.tsx - CollapsiblePanel - Collapsible section component
 * 
 * CHANGE HISTORY:
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
import React, { useState, useRef, useEffect } from 'react';
import { usePanel } from '../PanelrContext';

export const CollapsiblePanel = ({
  id,
  children,
  className = '',
  title,
  defaultOpen = true,
  persistent = true,
  icon = null,
  badge = null,
  onToggle
}) => {
  const { state, isOpen, toggle } = usePanel(id, {
    collapsible: true,
    persistent,
    isOpen: defaultOpen
  });

  const contentRef = useRef(null);
  const [height, setHeight] = useState(isOpen ? 'auto' : 0);

  useEffect(() => {
    if (contentRef.current) {
      if (isOpen) {
        const contentHeight = contentRef.current.scrollHeight;
        setHeight(contentHeight);
        // After animation, set to auto for dynamic content
        setTimeout(() => setHeight('auto'), 300);
      } else {
        setHeight(contentRef.current.scrollHeight);
        // Force reflow
        setTimeout(() => setHeight(0), 0);
      }
    }
  }, [isOpen]);

  const handleToggle = () => {
    toggle();
    onToggle?.(isOpen);
  };

  return (
    <div className={`collapsible-panel ${isOpen ? 'open' : 'closed'} ${className}`}>
      <button 
        className="collapsible-header"
        onClick={handleToggle}
        aria-expanded={isOpen}
      >
        <span className="collapsible-icon">
          {icon || (isOpen ? '▼' : '▶')}
        </span>
        <span className="collapsible-title">{title}</span>
        {badge && <span className="collapsible-badge">{badge}</span>}
      </button>
      
      <div 
        ref={contentRef}
        className="collapsible-content"
        style={{ 
          height: height === 'auto' ? 'auto' : `${height}px`,
          overflow: height === 'auto' ? 'visible' : 'hidden'
        }}
      >
        <div className="collapsible-inner">
          {children}
        </div>
      </div>
    </div>
  );
};

export default CollapsiblePanel;
